import { render, staticRenderFns } from "./MessagesFilter.vue?vue&type=template&id=1b94905a&scoped=true&"
import script from "./MessagesFilter.vue?vue&type=script&lang=js&"
export * from "./MessagesFilter.vue?vue&type=script&lang=js&"
import style0 from "./MessagesFilter.vue?vue&type=style&index=0&id=1b94905a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94905a",
  null
  
)

export default component.exports